module.exports = __webpack_public_path__ + "img/purse.ed347f24.png";